import type { CloneSurveyDto, GetCompanySurveysDto, SendBulkRemindersDto, SurveyBulkDeleteDto, SurveyCreateDto, SurveyDto, SurveyListPagedDto, SurveyRenameDto, SurveyUpdateDto, UpdateSurveyDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { SurveyTemplateDto } from '../survey-templates/models';

@Injectable({
  providedIn: 'root',
})
export class SurveysService {
  apiName = 'Default';
  

  bulkDelete = (input: SurveyBulkDeleteDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/aireadiness/surveys/survey-bulk-delete',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  clone = (request: CloneSurveyDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SurveyDto>({
      method: 'POST',
      url: '/api/aireadiness/surveys/clone',
      body: request,
    },
    { apiName: this.apiName,...config });
  

  closeSurvey = (key: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: `/api/aireadiness/surveys/close-survey/${key}`,
    },
    { apiName: this.apiName,...config });
  

  create = (input: SurveyCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SurveyDto>({
      method: 'POST',
      url: '/api/aireadiness/surveys',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (key: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/aireadiness/surveys/${key}`,
    },
    { apiName: this.apiName,...config });
  

  get = (key: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SurveyDto>({
      method: 'GET',
      url: `/api/aireadiness/surveys/${key}`,
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetCompanySurveysDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SurveyListPagedDto>({
      method: 'POST',
      url: '/api/aireadiness/surveys/survey-list',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  getQuestionnaire = (key: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SurveyTemplateDto>({
      method: 'GET',
      url: `/api/aireadiness/surveys/get-questionnaire/${key}`,
    },
    { apiName: this.apiName,...config });
  

  rename = (input: SurveyRenameDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'PUT',
      url: '/api/aireadiness/surveys/survey-rename',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  sendBulkReminders = (input: SendBulkRemindersDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/aireadiness/surveys/send-reminders-bulk',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  sendInvitations = (key: string, request: SurveyUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/aireadiness/surveys/send-invitations',
      params: { key },
      body: request,
    },
    { apiName: this.apiName,...config });
  

  update = (key: string, input: SurveyUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SurveyDto>({
      method: 'PUT',
      url: `/api/aireadiness/surveys/${key}`,
      body: input,
    },
    { apiName: this.apiName,...config });
  

  updateSurveyDateWithReminders = (input: UpdateSurveyDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/aireadiness/surveys/update-with-reminders',
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
